import { render, staticRenderFns } from "./UseAccountForFeeModal.vue?vue&type=template&id=003c7d2b"
import script from "./UseAccountForFeeModal.vue?vue&type=script&lang=js"
export * from "./UseAccountForFeeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports